import { Autocomplete, Box, Button, TextField } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import React, { useState } from 'react';
import styled from 'styled-components';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

import CustomHeader from '../../../components/common/header/CustomHeader';
import Sidebar from '../../../components/common/sidebar/Sidebar';
import OpaqueLoading from '../../../components/common/opaqueLoading/opaqueLoading';

const isMobile = window.innerWidth < 900;

const StaffEditorPageContainer = styled.div`
  width: 100%;
  ${isMobile && `position: relative;`}
`;

const CustomTableContainer = styled.div`
  width: 100%;
  border-radius: 20px;
`;

const Container = styled.div`
  width: 100%;
`;

const NotDiv = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  font-weight: 600;
`;

const quarters = [1, 2, 3, 4];

const quartersMonthMap = {
  1: ['April', 'May', 'June'],
  2: ['July', 'August', 'September'],
  3: ['October', 'November', 'December'],
  4: ['January', 'February', 'March'],
};

const eventTypes = [
  // 'Demo',
  'BFM',
  'OFM',
  'VM',
  // 'Van Campaign',
  // 'Retailer Meet',
  // 'Balloon Show',
  // 'Krishi Mela',
];

const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

const ViewTargetAchievement = () => {
  const [stateLoading, setStateLoading] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  const [targets, setTargets] = React.useState([]);
  const [total, setTotal] = React.useState(0);
  const [payload, setPayload] = React.useState({
    Year__c: new Date().getFullYear(),
    Event_Type__c: '',
    quarter: 1,
  });
  const [selectedYear, setSelectedYear] = React.useState(
    new Date().getFullYear()
  );
  const [selectedMonth, setSelectedMonth] = useState();
  const [selectedQuarter, setSelectedQuarter] = React.useState(1);
  const [selectedEvent, setSelectedEvent] = React.useState('');
  const [selectedEventF, setSelectedEventF] = React.useState('');
  const [years, setYears] = useState([]);
  const [events, setEvents] = useState([]);

  React.useEffect(() => {
    const user = JSON.parse(localStorage.getItem('storedUserData'));
    if (user) {
      const years = [];
      const currentYear = new Date().getFullYear();
      const currentMonth = months[new Date().getMonth()];
      const nextYear = currentYear + 1;
      years.push(currentYear);
      years.push(nextYear);
      setYears(years);
      getActivityType();
      setSelectedMonth(currentMonth);
      getMyTargets(currentYear, currentMonth);
    } else {
      window.location.reload();
    }
  }, []);

  const getActivityType = async () => {
    try {
      setLoading(true);
      const result = await window.Platform.database.getActivityType();
      setEvents(result.data);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const handleFilterChange = (key, value) => {
    if (key === 'Year__c') {
      // setPayload((p) => {
      //   return { ...p, quarter: 1, Event_Type__c: null };
      // });
      setSelectedYear(value);
      setSelectedMonth('');
      setSelectedEvent(null);
    } else if (key === 'Month__c') {
      setSelectedMonth(value);
      setSelectedEvent(null);
    } else {
      setSelectedEvent(value);
    }

    // setPayload((p) => {
    //   return { ...p, [key]: value };
    // });
  };

  const getMyTargets = async (defaultYear = null, defaultMonth = null) => {
    setSelectedEventF(selectedEvent);
    setPayload((p) => {
      // return {
      //   ...p,
      //   Year__c: selectedYear,
      //   quarter: selectedQuarter,
      //   Event_Type__c: selectedEvent,
      // };
      return {
        ...p,
        Year__c: typeof defaultYear === 'number' ? defaultYear : selectedYear,
        Month__c: defaultMonth ? defaultMonth : selectedMonth,
        Event_Type__c: selectedEvent?.value,
      };
    });

    // const payload = {
    //   Year__c: selectedYear,
    //   quarter: selectedQuarter,
    //   Event_Type__c: selectedEvent.value,
    // };
    const payload = {
      Year__c: typeof defaultYear === 'number' ? defaultYear : selectedYear,
      Month__c: defaultMonth ? defaultMonth : selectedMonth,
      Event_Type__c: selectedEvent?.value,
    };
    setTargets([]);
    setTotal(0);
    try {
      if (!payload.Year__c || !payload.Month__c) {
        window.NotificationUtils.showError(
          'Year and month must be selected to get filtered targets.'
        );
        return;
      }

      setLoading(true);
      const result = await window.Platform.database.getTargetActivityForRMM(
        payload
      );
      const finalResult = result.data.map((item) => {
        const obj = {
          ...item,
          [item.month__c]: item.target__c,
        };
        return obj;
      });
      setTargets(finalResult);
      setTotal(result.totalCount);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      window.NotificationUtils.showError(error?.message);
    }
  };

  const handleReset = (key) => {
    let currentPayload = {};
    setPayload((p) => {
      currentPayload = {
        ...p,
        [key]:
          key === 'Year__c'
            ? new Date().getFullYear()
            : key === 'quarter'
            ? 1
            : '',
      };
      return currentPayload;
    });
  };

  const renderContent = () => {
    return (
      <Box
        style={{
          height: !targets?.length ? '380px' : '550px',
          overflowY: 'auto',
        }}
      >
        <TableContainer
          sx={{
            boxShadow: 'none',
            overflowX: 'auto',
            maxHeight: 500,
          }}
          component={Paper}
        >
          <Table sx={{ minWidth: 650 }} aria-label='simple table'>
            <TableHead
              sx={{
                position: 'sticky',
                top: 0,
                zIndex: 3,
              }}
            >
              <TableRow sx={{ backgroundColor: '#77A600' }}>
                {![
                  'Van Campaign',
                  'Retailer Meet',
                  'Balloon Show',
                  'Krishi Mela',
                ].includes(selectedEventF) && (
                  <TableCell sx={{ color: '#FFF' }}>Product/Crop</TableCell>
                )}
                <TableCell sx={{ color: '#FFF' }}>Event Type</TableCell>
                <TableCell sx={{ color: '#FFF' }}>Total Targets</TableCell>
                {/* {payload.Month__c === 1 && (
                  <TableCell sx={{ color: '#FFF' }}>April</TableCell>
                )}
                {payload.quarter === 1 && (
                  <TableCell sx={{ color: '#FFF' }}>May</TableCell>
                )}
                {payload.quarter === 1 && (
                  <TableCell sx={{ color: '#FFF' }}>June</TableCell>
                )}
                {payload.quarter === 2 && (
                  <TableCell sx={{ color: '#FFF' }}>July</TableCell>
                )}
                {payload.quarter === 2 && (
                  <TableCell sx={{ color: '#FFF' }}>August</TableCell>
                )}
                {payload.quarter === 2 && (
                  <TableCell sx={{ color: '#FFF' }}>September</TableCell>
                )}
                {payload.quarter === 3 && (
                  <TableCell sx={{ color: '#FFF' }}>October</TableCell>
                )}
                {payload.quarter === 3 && (
                  <TableCell sx={{ color: '#FFF' }}>November</TableCell>
                )}
                {payload.quarter === 3 && (
                  <TableCell sx={{ color: '#FFF' }}>December</TableCell>
                )}
                {payload.quarter === 4 && (
                  <TableCell sx={{ color: '#FFF' }}>January</TableCell>
                )}
                {payload.quarter === 4 && (
                  <TableCell sx={{ color: '#FFF' }}>February</TableCell>
                )}
                {payload.quarter === 4 && (
                  <TableCell sx={{ color: '#FFF' }}>March</TableCell>
                )} */}

                {payload.Month__c === 'January' && (
                  <TableCell sx={{ color: '#FFF' }}>January</TableCell>
                )}
                {payload.Month__c === 'February' && (
                  <TableCell sx={{ color: '#FFF' }}>February</TableCell>
                )}
                {payload.Month__c === 'March' && (
                  <TableCell sx={{ color: '#FFF' }}>March</TableCell>
                )}
                {payload.Month__c === 'April' && (
                  <TableCell sx={{ color: '#FFF' }}>April</TableCell>
                )}
                {payload.Month__c === 'May' && (
                  <TableCell sx={{ color: '#FFF' }}>May</TableCell>
                )}
                {payload.Month__c === 'June' && (
                  <TableCell sx={{ color: '#FFF' }}>June</TableCell>
                )}
                {payload.Month__c === 'July' && (
                  <TableCell sx={{ color: '#FFF' }}>July</TableCell>
                )}
                {payload.Month__c === 'August' && (
                  <TableCell sx={{ color: '#FFF' }}>August</TableCell>
                )}
                {payload.Month__c === 'September' && (
                  <TableCell sx={{ color: '#FFF' }}>September</TableCell>
                )}
                {payload.Month__c === 'October' && (
                  <TableCell sx={{ color: '#FFF' }}>October</TableCell>
                )}
                {payload.Month__c === 'November' && (
                  <TableCell sx={{ color: '#FFF' }}>November</TableCell>
                )}
                {payload.Month__c === 'December' && (
                  <TableCell sx={{ color: '#FFF' }}>December</TableCell>
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {targets?.length > 0 &&
                targets.map((target, newIndex) => (
                  <TableRow
                    key={target?.productName}
                    sx={{
                      backgroundColor:
                        newIndex % 2 !== 0
                          ? 'rgba(119, 166, 0, 0.1)'
                          : 'inherit',
                      '&:last-child td, &:last-child th': { border: 0 },
                    }}
                  >
                    {![
                      'Van Campaign',
                      'Retailer Meet',
                      'Balloon Show',
                      'Krishi Mela',
                    ].includes(selectedEventF) && (
                      <TableCell component='th' scope='row'>
                        {target?.productName ? target?.productName : '-'}
                      </TableCell>
                    )}
                    <TableCell>{target.eventType}</TableCell>
                    <TableCell>
                      {Number(target?.April) +
                        Number(target?.May) +
                        Number(target?.June) +
                        Number(target?.July) +
                        Number(target?.August) +
                        Number(target?.September) +
                        Number(target?.October) +
                        Number(target?.November) +
                        Number(target?.December) +
                        Number(target?.January) +
                        Number(target?.February) +
                        Number(target?.March)}
                    </TableCell>
                    {/* {payload.quarter === 1 && (
                      <TableCell>{target?.April ? target?.April : 0}</TableCell>
                    )}
                    {payload.quarter === 1 && (
                      <TableCell>{target?.May ? target?.May : 0}</TableCell>
                    )}
                    {payload.quarter === 1 && (
                      <TableCell>{target?.June ? target?.June : 0}</TableCell>
                    )}
                    {payload.quarter === 2 && (
                      <TableCell>{target?.July ? target?.July : 0}</TableCell>
                    )}
                    {payload.quarter === 2 && (
                      <TableCell>
                        {target?.August ? target?.August : 0}
                      </TableCell>
                    )}
                    {payload.quarter === 2 && (
                      <TableCell>
                        {target?.September ? target?.September : 0}
                      </TableCell>
                    )}
                    {payload.quarter === 3 && (
                      <TableCell>
                        {target?.October ? target?.October : 0}
                      </TableCell>
                    )}
                    {payload.quarter === 3 && (
                      <TableCell>
                        {target?.November ? target?.November : 0}
                      </TableCell>
                    )}
                    {payload.quarter === 3 && (
                      <TableCell>
                        {target?.December ? target?.December : 0}
                      </TableCell>
                    )}
                    {payload.quarter === 4 && (
                      <TableCell>
                        {target?.January ? target?.January : 0}
                      </TableCell>
                    )}
                    {payload.quarter === 4 && (
                      <TableCell>
                        {target?.February ? target?.February : 0}
                      </TableCell>
                    )}
                    {payload.quarter === 4 && (
                      <TableCell>{target?.March ? target?.March : 0}</TableCell>
                    )} */}

                    {payload.Month__c === 'January' && (
                      <TableCell>{target?.January ?? 0}</TableCell>
                    )}
                    {payload.Month__c === 'February' && (
                      <TableCell>{target?.February ?? 0}</TableCell>
                    )}
                    {payload.Month__c === 'March' && (
                      <TableCell>{target?.March ?? 0}</TableCell>
                    )}
                    {payload.Month__c === 'April' && (
                      <TableCell>{target?.April ?? 0}</TableCell>
                    )}
                    {payload.Month__c === 'May' && (
                      <TableCell>{target?.May ?? 0}</TableCell>
                    )}
                    {payload.Month__c === 'June' && (
                      <TableCell>{target?.June ?? 0}</TableCell>
                    )}
                    {payload.Month__c === 'July' && (
                      <TableCell>{target?.July ?? 0}</TableCell>
                    )}
                    {payload.Month__c === 'August' && (
                      <TableCell>{target?.August ?? 0}</TableCell>
                    )}
                    {payload.Month__c === 'September' && (
                      <TableCell>{target?.September ?? 0}</TableCell>
                    )}
                    {payload.Month__c === 'October' && (
                      <TableCell>{target?.October ?? 0}</TableCell>
                    )}
                    {payload.Month__c === 'November' && (
                      <TableCell>{target?.November ?? 0}</TableCell>
                    )}
                    {payload.Month__c === 'December' && (
                      <TableCell>{target?.December ?? 0}</TableCell>
                    )}
                  </TableRow>
                ))}
              <TableRow
                sx={{
                  position: 'sticky',
                  bottom: 0,
                  zIndex: 3,
                  backgroundColor: '#77A600',
                }}
              >
                <TableCell sx={{ color: '#FFF' }}>Total</TableCell>
                {![
                  'Van Campaign',
                  'Retailer Meet',
                  'Balloon Show',
                  'Krishi Mela',
                ].includes(selectedEventF) && (
                  <TableCell sx={{ backgroundColor: '#FFF' }} />
                )}
                <TableCell sx={{ backgroundColor: '#FFF' }}>
                  {targets?.reduce((sum, target) => {
                    return (
                      sum +
                      [
                        target?.April,
                        target?.May,
                        target?.June,
                        target?.July,
                        target?.August,
                        target?.September,
                        target?.October,
                        target?.November,
                        target?.December,
                        target?.January,
                        target?.February,
                        target?.March,
                      ].reduce((s, val) => s + Number(val || 0), 0)
                    );
                  }, 0)}
                </TableCell>
                {/* {[
                  'April',
                  'May',
                  'June',
                  'July',
                  'August',
                  'September',
                  'October',
                  'November',
                  'December',
                  'January',
                  'February',
                  'March',
                ]
                  .filter((month) =>
                    quartersMonthMap[String(payload.quarter)].includes(month)
                  )
                  .map((month) => (
                    <TableCell key={month} sx={{ backgroundColor: '#FFF' }}>
                      {targets?.reduce(
                        (sum, target) => sum + Number(target?.[month] || 0),
                        0
                      )}
                    </TableCell>
                  ))} */}
                {[
                  'April',
                  'May',
                  'June',
                  'July',
                  'August',
                  'September',
                  'October',
                  'November',
                  'December',
                  'January',
                  'February',
                  'March',
                ]
                  .filter((month) => month === payload.Month__c)
                  .map((month) => (
                    <TableCell key={month} sx={{ backgroundColor: '#FFF' }}>
                      {targets?.reduce(
                        (sum, target) => sum + Number(target?.[month] || 0),
                        0
                      )}
                    </TableCell>
                  ))}
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    );
  };

  return (
    <div
      style={{
        display: 'flex',
        width: '100%',
        backgroundColor: '#F6F6F6',
        minHeight: '100vh',
      }}
    >
      <Sidebar />
      <Container>
        {loading && <OpaqueLoading />}

        <CustomHeader name='target-achievement' />
        <Box p={4}>
          <Box
            display='flex'
            flexDirection='row'
            alignItems='center'
            justifyContent='flex-end'
          >
            <Box display='flex' alignItems='center' gap='10px' mb={2}>
              <Autocomplete
                size='small'
                sx={{ width: '200px' }}
                value={selectedYear || null}
                onChange={(event, newValue) =>
                  handleFilterChange('Year__c', newValue)
                }
                // onInputChange={(event, newInputValue, reason) => {
                //   if (reason === 'clear') {
                //     handleReset('Year__c');
                //     return;
                //   }
                // }}
                options={years}
                getOptionLabel={(option) => option}
                isOptionEqualToValue={(option, value) => option === value}
                autoComplete='off'
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label='Select Year'
                    slotProps={{
                      input: {
                        ...params.InputProps,
                        endAdornment: (
                          <React.Fragment>
                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        ),
                      },
                    }}
                  />
                )}
                filterOptions={(options, { inputValue }) => {
                  return options.filter((option) =>
                    String(option)
                      .toLowerCase()
                      .includes(inputValue.toLowerCase())
                  );
                }}
              />

              <Autocomplete
                size='small'
                sx={{ width: '200px' }}
                value={selectedMonth || null}
                onChange={(event, newValue) =>
                  handleFilterChange('Month__c', newValue)
                }
                options={months}
                getOptionLabel={(option) => option}
                isOptionEqualToValue={(option, value) => option === value}
                autoComplete='off'
                // getOptionDisabled={(option) => {
                //   const currentDate = new Date();
                //   const currentMonthIndex = currentDate.getMonth();
                //   const currentYear = currentDate.getFullYear();

                //   if (parseInt(selectedYear) === currentYear) {
                //     const monthIndex = months.findIndex(
                //       (month) => month.toLowerCase() === option.toLowerCase()
                //     );
                //     return monthIndex < currentMonthIndex;
                //   }
                //   return false;
                // }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label='Select Month'
                    slotProps={{
                      input: {
                        ...params.InputProps,
                        endAdornment: (
                          <React.Fragment>
                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        ),
                      },
                    }}
                  />
                )}
                filterOptions={(options, { inputValue }) => {
                  return options.filter((option) =>
                    option.toLowerCase().includes(inputValue.toLowerCase())
                  );
                }}
              />
              {/* <Autocomplete
                name='quarter'
                sx={{ width: '150px' }}
                size='small'
                value={payload.quarter || null}
                onChange={(event, newValue) =>
                  handleFilterChange('quarter', newValue)
                }
                // onInputChange={(event, newInputValue, reason) => {
                //   if (reason === 'clear') {
                //     handleReset('quarter');
                //     return;
                //   }
                // }}
                options={quarters}
                getOptionLabel={(option) => option}
                isOptionEqualToValue={(option, value) => option === value}
                fullWidth
                autoComplete='off'
                loading={stateLoading}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label='Select Quarter'
                    slotProps={{
                      input: {
                        ...params.InputProps,
                        endAdornment: (
                          <React.Fragment>
                            {stateLoading ? (
                              <CircularProgress color='inherit' size={20} />
                            ) : null}
                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        ),
                      },
                    }}
                  />
                )}
                filterOptions={(options, state) => {
                  return options.filter((option) => option);
                }}
              /> */}

              <Autocomplete
                size='small'
                sx={{ width: '200px' }}
                // value={selectedEvent || null}
                // onChange={(event, newValue) => handleEventChange(newValue)}
                value={selectedEvent || null}
                onChange={(event, newValue) =>
                  handleFilterChange('Event_Type__c', newValue)
                }
                options={events}
                getOptionLabel={(option) =>
                  typeof option === 'string' ? option : option?.eventName || ''
                }
                isOptionEqualToValue={(option, value) =>
                  option.eventName === value
                }
                fullWidth
                autoComplete='off'
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label='Select Event Type'
                    // onChange={(event) =>
                    //   debouncedSearchField(event, 'Expense Owner')
                    // }
                    slotProps={{
                      input: {
                        ...params.InputProps,
                        endAdornment: (
                          <React.Fragment>
                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        ),
                      },
                    }}
                  />
                )}
                filterOptions={(options, { inputValue }) => {
                  return options.filter((option) =>
                    option.eventName
                      .toLowerCase()
                      .includes(inputValue.toLowerCase())
                  );
                }}
              />

              {/* <Autocomplete
                name='Event_Type__c'
                sx={{ width: '150px' }}
                size='small'
                value={payload.Event_Type__c || null}
                onChange={(event, newValue) =>
                  handleFilterChange('Event_Type__c', newValue)
                }
                // onInputChange={(event, newInputValue, reason) => {
                //   if (reason === 'clear') {
                //     handleReset('Event_Type__c');
                //     return;
                //   }
                // }}
                options={eventTypes}
                getOptionLabel={(option) => option}
                isOptionEqualToValue={(option, value) => option === value}
                fullWidth
                autoComplete='off'
                loading={stateLoading}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label='Event Type'
                    slotProps={{
                      input: {
                        ...params.InputProps,
                        endAdornment: (
                          <React.Fragment>
                            {stateLoading ? (
                              <CircularProgress color='inherit' size={20} />
                            ) : null}
                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        ),
                      },
                    }}
                  />
                )}
                filterOptions={(options, state) => {
                  return options.filter((option) => option?.toLowerCase());
                }}
              /> */}
              <Button
                variant='contained'
                style={{
                  background:
                    'linear-gradient(90deg, #77A600 0%, #A8CF45 100%)',
                }}
                onClick={getMyTargets}
              >
                Fetch
              </Button>
            </Box>
          </Box>
          <StaffEditorPageContainer>
            {targets?.length > 0 ? (
              <CustomTableContainer>{renderContent()}</CustomTableContainer>
            ) : (
              <NotDiv>No Data Found</NotDiv>
            )}
          </StaffEditorPageContainer>
        </Box>
      </Container>
    </div>
  );
};

export default ViewTargetAchievement;
